module.exports = __webpack_public_path__ + "static/img/double_fun_bg.fdbca83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/double_fun_bg.png
// module id = RR4V
// module chunks = 0